import React from 'react';
import { DollarSign, TrendingUp, Clock, Tag, Home, BarChart3, ExternalLink } from 'lucide-react';
const ZILLOW = 'https://www.zillow.com/profile/RothGetsResults';
const FAST = 'https://www.fastexpert.com/agents/krystle-roth-2375/';
const REDFIN = 'https://www.redfin.com/zipcode/92373/housing-market';
const agentMetrics = [{
  id: 'sales_l12m',
  label: 'Sales · last 12 months',
  value: '52',
  context: 'Team total per Zillow profile',
  icon: BarChart3,
  source: {
    label: 'Zillow',
    url: ZILLOW
  }
}, {
  id: 'lifetime',
  label: 'Lifetime sales',
  value: '514',
  context: 'Team total per Zillow profile',
  icon: Home,
  source: {
    label: 'Zillow',
    url: ZILLOW
  }
}, {
  id: 'avg_price',
  label: 'Average price',
  value: '$634K',
  context: 'Per-transaction average',
  icon: Tag,
  source: {
    label: 'Zillow',
    url: ZILLOW
  }
}, {
  id: 'volume',
  label: 'Annual volume',
  value: '$42M',
  context: 'Trailing 12-month total',
  icon: DollarSign,
  source: {
    label: 'FastExpert',
    url: FAST
  }
}];
const marketMetrics = [{
  id: 'price_range',
  label: 'Price range served',
  value: '$66K – $1.6M',
  context: 'Across all 514 closed transactions',
  icon: TrendingUp,
  source: {
    label: 'Zillow',
    url: ZILLOW
  }
}, {
  id: 'zip_median',
  label: '92373 median sale price',
  value: '$735K',
  context: 'Redlands ZIP, most recent Redfin report',
  icon: TrendingUp,
  source: {
    label: 'Redfin',
    url: REDFIN
  }
}, {
  id: 'zip_dom',
  label: '92373 days on market',
  value: '44 days',
  context: 'Median, Redfin most recent report',
  icon: Clock,
  source: {
    label: 'Redfin',
    url: REDFIN
  }
}];
function MetricCard({
  m
}: {
  m: any;
}) {
  const Icon = m.icon;
  return <div className="bg-white px-4 py-4 rounded-xl shadow-premium border border-brand-light" data-id="element-176">
      <div className="flex items-center justify-between mb-3" data-id="element-177">
        <div className="w-8 h-8 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest" data-id="element-178">
          <Icon size={16} data-id="element-179" />
        </div>
        <a href={m.source.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[10px] font-medium text-brand-muted hover:text-brand-forest bg-brand-offwhite border border-brand-light px-2 py-0.5 rounded-full" data-id="element-180">
          {m.source.label}
          <ExternalLink size={10} data-id="element-181" />
        </a>
      </div>
      <h3 className="text-2xl font-mono text-brand-dark mb-1" data-id="element-182">{m.value}</h3>
      <p className="text-xs text-brand-muted leading-snug mb-1" data-id="element-183">{m.label}</p>
      <p className="text-[11px] text-brand-muted leading-snug" data-id="element-184">{m.context}</p>
    </div>;
}
export function PerformanceMetrics() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-185">
      <div className="mb-6" data-id="element-186">
        <h2 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-187">
          Verified performance & market context
        </h2>
        <p className="text-sm text-brand-muted max-w-2xl" data-id="element-188">
          Every figure on this page is sourced to a public, linkable record.
          Sale-vs-market and speed-to-close comparisons require county
          recorder cross-references and are pending verification.
        </p>
      </div>

      <div className="mb-3" data-id="element-189">
        <p className="text-[11px] font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-190">
          Agent · verified from public profiles
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-191">
          {agentMetrics.map(m => <MetricCard key={m.id} m={m} data-id="element-192" />)}
        </div>
      </div>

      <div className="mt-5" data-id="element-193">
        <p className="text-[11px] font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-194">
          Range & ZIP market context
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-195">
          {marketMetrics.map(m => <MetricCard key={m.id} m={m} data-id="element-196" />)}
        </div>
      </div>
    </section>;
}